<template>
  <div class="navbar-container">
    <div class="mask" v-if="ifToast" @click="hideToast"></div>
    <div class="main">
      <img class="logo" @click="goToNav('home', '1')" src="../../assets/logo.png" alt="">
      <div class="block"></div>
      <div class="leftBox">
        <div class="line1">
          <!-- 搜索框区域 -->
          <div class="search-wrapper">
            <a-input placeholder="请输入内容" class="searchBox" allow-clear v-model:value="searchValue"
              @input="handleSearchInput" @focus="isSearchFocused = true">
              <template #prefix>
                <img @click="handleSearchInput" v-lazy-load :data-src="require('../../assets/icon11.png')" alt="">
              </template>
            </a-input>

            <!-- 搜索结果下拉框 -->
            <div class="search-results" v-if="showSearchResults">
              <div class="search-loading" v-if="searchStatus === 'loading'">
                <a-spin size="small" />
                <span>搜索中...</span>
              </div>

              <div class="search-error" v-else-if="searchStatus === 'error'">
                <!-- <img src="../../assets/error-icon.png" alt="错误" class="status-icon"> -->
                <span>搜索异常，请重试</span>
              </div>

              <div class="search-empty" v-else-if="searchStatus === 'empty'">
                <!-- <img src="../../assets/empty-icon.png" alt="空结果" class="status-icon"> -->
                <span>暂无搜索结果</span>
              </div>

              <div class="search-items" v-else-if="searchStatus === 'success'">
                <div v-for="(item, index) in searchResults" :key="index" class="search-item"
                  @click="goToSearchResult(item)">
                  {{ item.label }}
                  <span class="login-required" v-if="item.isLogin">(需登录)</span>
                </div>
              </div>
            </div>
          </div>

          <div class="loginBox" v-if="!token" @click="switchIdentity('login')">登录/注册</div>
          <div class="loginBox" v-else @click="goToNav('memberhome')">切换到工作台</div>
        </div>
        <div class="line2">
          <!-- 原有导航代码保持不变 -->
          <div :class="currentPage === 'home' ? 'nav2' : 'nav1'" @click="showToast">
            <div class="toast" v-show="ifToast" @click="a">
              <div class="content" @click="goToNav('home', '1')">什么是制造业企业ESG评价</div>
              <div class="content" @click="goToNav('home', '2')">ESG术语与定义</div>
              <div class="content" @click="goToNav('home', '3')">制造业企业ESG评价过程</div>
            </div>
            制造业企业ESG评价
            <img class="arrow" v-lazy-load :data-src="require('../../assets/arrow1-1.png')" alt="">
          </div>
          <div :class="currentPage === 'consult' ? 'nav2 mgl' : 'nav1 mgl'" @click="goToNav('consult')">政策资讯</div>
          <div :class="currentPage === 'case' ? 'nav2 mgl' : 'nav1 mgl'" @click="goToNav('case')">客户案例</div>
          <div :class="currentPage === 'service' ? 'nav2 mgl' : 'nav1 mgl'" @click="goToNav('service')">服务介绍</div>
          <div :class="currentPage === 'about' ? 'nav2 mgl' : 'nav1 mgl'" @click="goToNav('about')">关于我们</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, watch, computed, useModel } from 'vue'
import { useRouter, useRoute } from 'vue-router';
import { debounce } from 'lodash';
import Api from '@/utils/api'

// 定义组件属性
const props = defineProps({
  path: {
    type: String,
    default: 'home'
  },
})
const token = ref(localStorage.getItem('token'))

const router = useRouter()
const route = useRoute()
const ifToast = ref(false)
const currentPage = useModel(props, 'path')

//添加防重复点击状态
const isNavigating = ref(false)
const NAVIGATION_DELAY = 508//导航防抖延迟时间，单位秒

// 搜索相关状态
const searchValue = ref('')
const searchStatus = ref('') // '', 'loading', 'success', 'error', 'empty'
const searchResults = ref([])
const isSearchFocused = ref(false)
// 添加AbortController用于取消之前的请求
let abortController = null

// 计算属性：是否显示搜索结果下拉框
const showSearchResults = computed(() => {
  return isSearchFocused.value && searchValue.value.trim() &&
    (searchStatus.value === 'loading' ||
      searchStatus.value === 'success' ||
      searchStatus.value === 'error' ||
      searchStatus.value === 'empty')
})

watch(
  () => route.path,
  (newPath) => {
    console.log('路径变化', newPath)
    currentPage.value = newPath.replace(/^\//, '') || 'home';
    token.value = localStorage.getItem('token')
  }
);

const emit = defineEmits(['updatePage', 'updateIdentity'])

const showToast = () => {
  ifToast.value = !ifToast.value
}

const hideToast = () => {
  ifToast.value = false
}

const goToNav = async (page, val) => {
  // 如果正在导航中，直接返回
  if (isNavigating.value) {
    return
  }

  // 设置导航状态为进行中
  isNavigating.value = true

  try {
    currentPage.value = page
    if (val) {
      await router.push({
        path: page,
        query: {
          valtop: val
        }
      })
    } else {
      await router.push(page)
    }
    emit('updatePage', page)
  } catch (error) {
    console.error('导航错误:', error)
  } finally {
    // 导航完成后，延迟重置导航状态，防止快速连续点击
    setTimeout(() => {
      isNavigating.value = false
    }, NAVIGATION_DELAY)
  }
}

// 点击搜索结果项
const goToSearchResult = (item) => {
  // 检查是否需要登录
  if (item.isLogin) {
    // 如果需要登录，跳转到登录页面
    router.push({
      path: '/login',
      query: {
        currentIdentity: 'login'
      }
    })
  } else {
    // 否则跳转到对应路径
    router.push(item.path)
  }

  // 清空搜索状态
  searchValue.value = ''
  isSearchFocused.value = false
  searchStatus.value = ''
}

// 搜索处理
const handleSearchInput = () => {
  const keyword = searchValue.value.trim()
  if (keyword) {
    searchStatus.value = 'loading'
    doSearch(keyword)
  } else {
    searchStatus.value = ''
    searchResults.value = []
  }
}

// 实际搜索函数
const doSearch = debounce(async (keyword) => {
  try {

    // 取消之前的请求
    if (abortController) {
      abortController.abort()
    }

    // 创建新的AbortController
    abortController = new AbortController()

    const res = await Api.onSearch({
      query: keyword
    }, {
      signal: abortController.signal
    })

    if (res.code === 200) {
      // 解析返回的数据
      let data = []
      try {
        // 处理可能的字符串格式数据
        data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
      } catch (e) {
        console.error('解析搜索结果失败:', e)
        data = []
      }

      searchResults.value = data
      searchStatus.value = data.length > 0 ? 'success' : 'empty'
    } else {
      searchStatus.value = 'error'
      searchResults.value = []
    }
  } catch (error) {
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
      return
    }
    searchStatus.value = 'error'
    searchResults.value = []
  }
}, 500)

const switchIdentity = (identity) => {
  router.push({
    path: 'login',
    query: {
      currentIdentity: 'login'
    }
  })
  emit('updateIdentity', identity)
}

// 点击页面其他地方关闭搜索结果
document.addEventListener('click', (e) => {
  const searchWrapper = document.querySelector('.search-wrapper')
  if (searchWrapper && !searchWrapper.contains(e.target)) {
    isSearchFocused.value = false
  }
})
</script>

<style lang="scss" scoped>
.navbar-container {
  width: 100%;
  height: 100%;
}

.main {
  width: 100%;
  height: 100%;
  min-width: 1100px;
  max-width: 1980px;
  background-color: #fff;
  box-shadow: 0px 4px 10.1px 0px rgba(0, 0, 0, 0.10);
  display: flex;
  flex-direction: row;
  align-items: center;

  .logo {
    width: 168px;
    height: 124px;
    margin: 10px 0;
    margin-left: 80px;
  }

  .leftBox {
    display: flex;
    flex-direction: column;
    margin-right: 80px;
    height: 100%;
    justify-content: space-around;
    align-items: end;

    .line1 {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 23px;
      position: relative;

      // 搜索包装器
      .search-wrapper {
        position: relative;

        .searchBox {
          width: 200px;
          height: 40px;
          border-radius: 4px;
          display: flex;
          flex-direction: row;
          align-items: center;
          color: rgba(16, 38, 59, 0.60);
          font-size: 15px;
          font-weight: 400;
          background-color: transparent;

          img {
            width: 16px;
            height: 16px;
            margin-left: 10px;
            margin-right: 10px;
            cursor: pointer;
          }
        }

        // 搜索结果下拉框
        .search-results {
          position: absolute;
          top: 45px;
          left: 0;
          width: 100%;
          background: #fff;
          border-radius: 4px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          z-index: 1000;
          max-height: 300px;
          overflow-y: auto;

          .search-loading,
          .search-error,
          .search-empty {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px;
            color: rgba(16, 38, 59, 0.60);

            .status-icon {
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }
          }

          .search-items {
            .search-item {
              padding: 0 16px;
              line-height: 3;
              cursor: pointer;
              color: #26734C;
              font-size: 14px;
              border-bottom: 1px solid rgba(38, 115, 76, 0.1);
              display: flex;
              justify-content: space-between;
              align-items: center;

              &:last-child {
                border-bottom: none;
              }

              &:hover {
                background-color: rgba(38, 115, 76, 0.05);
              }

              .login-required {
                font-size: 12px;
                color: #ff4d4f;
                margin-left: 8px;
              }
            }
          }
        }
      }

      .loginBox {
        width: 110px;
        height: 40px;
        border-radius: 4px;
        background-color: #26734C;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: 400;
        font-size: 16px;
        cursor: pointer;
        margin-left: 30px;
      }
    }

    // 原有导航样式保持不变
    .line2 {
      display: flex;
      flex-direction: row;
      align-items: center;

      .nav1 {
        font-size: 16px;
        color: #26734C;
        cursor: pointer;
        position: relative;
        border-bottom: 2px solid transparent;
        padding-bottom: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 1.2;
      }

      .mgl {
        margin-left: 66px;
      }

      .nav2 {
        position: relative;
        font-size: 16px;
        color: #1F4733;
        border-bottom: 2px solid #1F4733;
        padding-bottom: 4px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        line-height: 1.2;
      }

      .toast {
        position: absolute;
        top: 47px;
        z-index: 11;
        background-color: #fff;
        border-radius: 3px;
        box-shadow: 0 0 8px 0px rgba(82, 90, 102, 0.08);
        clip-path: inset(0 -9px -9px -9px);
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .content {
          box-sizing: border-box;
          padding: 0 10px;
          display: flex;
          align-items: center;
          white-space: nowrap;
          color: #26734C;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
          padding: 12px;
          box-sizing: border-box;
        }
      }

      .arrow {
        width: 12px;
        height: 12px;
        margin-left: 10px;
      }
    }
  }

  .block {
    flex: 1;
  }
}

.mask {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 9;
}
</style>